(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin-data/games/assets/javascripts/services/fetch-games.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin-data/games/assets/javascripts/services/fetch-games.js');
"use strict";


const cachedJupiterGet = svs.components.marketplaceData.cachedJupiterGet;
const normalizeGame = svs.components.marketplaceRetailAdminData.games.helpers.normalizeGame;
const fetchGames = (excludedIds, callback) => {
  const urls = ["/retailer/1/marketplace/activateddraws"];
  fetchGames.cacheRequest(urls, response => {
    let gamesResponse;
    try {
      gamesResponse = response.responses[0];
    } catch (err) {
      callback({
        message: err
      });
      return;
    }
    if (!gamesResponse.activatedDraws) {
      callback({
        message: 'missing `activatedDrawId` on response'
      });
      return;
    }
    const normalizedActivatedDraws = gamesResponse.activatedDraws.map(game => normalizeGame(game));
    const filteredGames = normalizedActivatedDraws.filter(game => excludedIds.indexOf(game.activatedDrawId) === -1);
    callback(undefined, filteredGames);
  }, error => {
    callback(error.responseJSON.error);
  });
};
fetchGames.cacheRequest = cachedJupiterGet.createCache(1000);
setGlobal('svs.components.marketplaceRetailAdminData.games.services.fetchGames', fetchGames);

 })(window);